import React, { useState } from "react";
import { EquipmentV2Label } from "../../../utils/labels";
import * as ContentStyles from "../styles/EquipmentContent";
import Icon from "../../../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import { ToggleIconWrapper } from "../../../../../../common-deprecated/styles/v2/toyota/globals/IconWrapper";
import { trackEquipmentDescriptionToggle } from "../../../utils/tracking";
import { useEquipmentV2Selector } from "../../../redux/store";

type EquipmentDescriptionProps = {
    description: string;
    categoryId: string; // necessary for tracking
    categoryName: string; // necessary for tracking
    equipmentId: string; // necessary for tracking
    equipmentName: string; // necessary for tracking
};

const EquipmentDescription = (props: EquipmentDescriptionProps): JSX.Element => {
    const { description, categoryId, categoryName, equipmentId, equipmentName } = props;
    const componentName = useEquipmentV2Selector((state) => state.commonSettings.component);
    const [isOpen, setIsOpen] = useState(false);

    const toggle = (): void => {
        setIsOpen(!isOpen);
        trackEquipmentDescriptionToggle(componentName, categoryId, categoryName, equipmentId, equipmentName);
    };

    return (
        <>
            <ContentStyles.Header onClick={toggle}>
                <EquipmentV2Label label="equipmentMoreInformation" />
                <ToggleIconWrapper isDown={isOpen} iconColor="primaryBlack">
                    <Icon variant="chevronDown" />
                </ToggleIconWrapper>
            </ContentStyles.Header>
            <ContentStyles.Toggle isOpen={isOpen} dangerouslySetInnerHTML={{ __html: description }} />
        </>
    );
};

export default EquipmentDescription;
